/**
 * Created by Ivan on 18.11.2025
 */

Placements.ENTRIES["kingsCupStart"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1,
    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_KINGSCUP);
        return mission && mission.logic.readyToUnlock;
    },
    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_KINGSCUP);
        delete mission.logic.readyToUnlock;
        mission.logic.startCompetition();
    }
};
